<template>
  <div class="col">
    <div class="form-group">
      <label class="control-label" for="type">Último Curso</label>
      <p :class="lastCourse.grade_final_grade != null ? 'mb-0' : ''">
        {{ lastCourse.course_name !== null ? lastCourse.course_name : "-" }}
      </p>
      <CBadge
        :color="
          lastCourse.grade_final_grade == 0
            ? 'danger'
            : lastCourse.grade_final_grade < 75
            ? 'danger'
            : lastCourse.grade_final_grade >= 75 &&
              lastCourse.grade_final_grade <= 79
            ? 'warning'
            : lastCourse.grade_final_grade > 79
            ? 'success'
            : 'danger'
        "
        class="badge-grade"
      >
        <b>{{
          lastCourse.grade_id !== 0
            ? `Nota Final:${lastCourse.grade_final_grade}`
            : "Aún no se registró nota del curso."
        }}</b>
      </CBadge>
    </div>
  </div>
</template>
<script>
export default {
  name: "LastScheduledCourse",
  props: {
    lastCourse: { required: true },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style scoped>
.badge-grade {
  font-size: 0.9rem;
}
</style>